import React, { Fragment } from 'react';

import BreadCrumbs from '../../BreadCrumbs';
import CareerClusterHeaderTitle from '../careerClusterHeader/CareerClusterHeaderTitle';
import SubHeader from '../common/SubHeader';

const JobSearchRemoteClusterHeader = ({ subPageName, headerTitle, ...data }) => {
  const { breadCrumbs } = data;
  const title = headerTitle || 'LGBTQ';
  return (
    <Fragment>
      <div className="job-search-remote container">
        <div className="job-search-remote-row d-none d-md-flex" style={{ height: '32px' }}>
          {breadCrumbs && (
            <BreadCrumbs
              breadCrumbs={breadCrumbs.slice(0, 3)}
              containerClassName={'cluster-header-breadcrumbs-container'}
            />
          )}
        </div>
        <CareerClusterHeaderTitle subPageName={subPageName} title={title} noH1Tag />
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </Fragment>
  );
};

export default JobSearchRemoteClusterHeader;
